/**
 * THIS FILE IS AUTO-GENERATED. DO NOT MODIFY! */
import type { ActAsUserFilterInput, AssetFilterInput, AsyncTaskFilterInput, AttachmentTemplateFilterInput, AuditLogFilterInput, BatchFilterInput, BatchScheduleFilterInput, BranchFilterInput, BuildTypeFilterInput, BuilderFilterInput, BusinessRoleFilterInput, CandidateFilterInput, CandidateIngestionPolicyFilterInput, ClientFilterInput, ConfiguredLinkedActionFilterInput, CorrespondenceFilterInput, CostingFilterInput, CostingLineFilterInput, CostingLineTemplateFilterInput, CostingRevisionFilterInput, CostingTemplateExpressionFilterInput, CostingTemplateFilterInput, CostingTemplateRevisionFilterInput, CustomDataFilterInput, CustomTemplateFilterInput, DefaultFolderFilterInput, DeliveryAddressFilterInput, DocumentTemplateFilterInput, EmailFilterInput, ExternalStorageConnectionFilterInput, ExternalStorageResourceMappingFilterInput, FileFilterInput, GroupTemplateFilterInput, HousingCompanyFilterInput, IssueFilterInput, JobComponentFilterInput, JobFilterInput, LeadFilterInput, LineItemFilterInput, LineItemMasterWorkflowFilterInput, LinkedActionFilterInput, LostReasonFilterInput, NotificationTemplateFilterInput, PanelFilterInput, PartTypeFilterInput, PersonAssignedWorkFilterInput, PersonBusinessRoleFilterInput, PersonFilterInput, ProcessAssetFilterInput, ProcessAssignmentFilterInput, ProcessInstanceFilterInput, ProcessTemplateFilterInput, ProcessTimerFilterInput, ProcessTimerItemFilterInput, ProcessTypeFilterInput, ProcessTypeNoteFilterInput, ProcessTypeRoleFilterInput, ProductCategoryFilterInput, ProductCategoryGroupFilterInput, ProductFilterInput, ProductPriceFilterInput, ProjectFilterInput, PurchaseOrderFilterInput, PurchaseOrderLineFilterInput, PurchaseOrderReceiptFilterInput, PurchaseOrderReceiptLineFilterInput, PurchaseOrderReviewFilterInput, QuoteFilterInput, QuoteLineFilterInput, QuoteLineTemplateFilterInput, QuoteRevisionFilterInput, QuoteTemplateExpressionFilterInput, QuoteTemplateFilterInput, QuoteTemplateRevisionFilterInput, RecordFileFilterInput, RecordFolderFilterInput, RecordScreenFilterInput, RecordTagFilterInput, RegionFilterInput, RoleFilterInput, RoleInheritanceFilterInput, RolePermissionFilterInput, RoleUserFilterInput, SaleTypeFilterInput, SalesOrderFilterInput, SalesOrderLineFilterInput, SchemaFilterInput, SchemaVersionFilterInput, ScreenFilterInput, StockFilterInput, StockTransactionFilterInput, StockTransactionLineFilterInput, SubscriptionRealFilterInput, SupplierCategoryFilterInput, SupplierFilterInput, SupplierQuoteFilterInput, SupplierQuoteLineFilterInput, SupplierQuoteRequestFilterInput, SupplierQuoteRequestLineFilterInput, TagFilterInput, TimerTransactionFilterInput, UserFilterInput, UserIdentityFilterInput, UserPermissionFilterInput, UserRoleFilterInput, WarehouseFilterInput, WebhookFilterInput, WorkflowNoteFilterInput, WorkflowTemplateFilterInput, WorkflowTypeFilterInput } from "src/gql/graphql";
export enum Permission {
    Create_Batch = "Create_Batch",
    Create_Branch = "Create_Branch",
    Create_Builder = "Create_Builder",
    Create_Candidate = "Create_Candidate",
    Create_Client = "Create_Client",
    Create_Costing = "Create_Costing",
    Create_Costing_Template = "Create_Costing_Template",
    Create_Document_Template = "Create_Document_Template",
    Create_Files = "Create_Files",
    Create_Firebase_Auth_Token = "Create_Firebase_Auth_Token",
    Create_Housing_Company = "Create_Housing_Company",
    Create_Housing_Company_Image = "Create_Housing_Company_Image",
    Create_Issue = "Create_Issue",
    Create_Job = "Create_Job",
    Create_Job_Component = "Create_Job_Component",
    Create_Job_File = "Create_Job_File",
    Create_Job_Part = "Create_Job_Part",
    Create_Lead = "Create_Lead",
    Create_Lost_Reason = "Create_Lost_Reason",
    Create_Panel = "Create_Panel",
    Create_Part_Type = "Create_Part_Type",
    Create_Person = "Create_Person",
    Create_Business_Role = "Create_Business_Role",
    Create_Process_Type = "Create_Process_Type",
    Create_Process_Type_Role = "Create_Process_Type_Role",
    Create_Process_Type_Note = "Create_Process_Type_Note",
    Create_Product = "Create_Product",
    Create_Product_Category = "Create_Product_Category",
    Create_Product_Price = "Create_Product_Price",
    Create_Purchase_Order = "Create_Purchase_Order",
    Create_Purchase_Order_Receipt = "Create_Purchase_Order_Receipt",
    Create_Quote = "Create_Quote",
    Create_Quote_Request = "Create_Quote_Request",
    Create_Quote_Template = "Create_Quote_Template",
    Create_Role = "Create_Role",
    Create_Sales_Order = "Create_Sales_Order",
    Create_Role_Screen = "Create_Role_Screen",
    Create_Schema = "Create_Schema",
    Create_Schema_Version = "Create_Schema_Version",
    Create_Screen = "Create_Screen",
    Create_Storage_Connection = "Create_Storage_Connection",
    Create_Storage_Resource_Mapping = "Create_Storage_Resource_Mapping",
    Create_Subscription = "Create_Subscription",
    Create_Supplier = "Create_Supplier",
    Create_Supplier_Image = "Create_Supplier_Image",
    Create_Supplier_Quote = "Create_Supplier_Quote",
    Create_Tag = "Create_Tag",
    Create_User = "Create_User",
    Create_User_Identity = "Create_User_Identity",
    Create_Warehouse = "Create_Warehouse",
    Query_Configured_Linked_Actions = "Query_Configured_Linked_Actions",
    Manage_Configured_Linked_Actions = "Manage_Configured_Linked_Actions",
    Query_Linked_Actions = "Query_Linked_Actions",
    Manage_Favourite_Linked_Actions = "Manage_Favourite_Linked_Actions",
    Create_Webhook = "Create_Webhook",
    Create_Workflow_Type = "Create_Workflow_Type",
    Convert_Candidate = "Convert_Candidate",
    Set_Candidate_Ingestion_Policy = "Set_Candidate_Ingestion_Policy",
    Update_Batch_Details = "Update_Batch_Details",
    Update_Branch = "Update_Branch",
    Update_Builder = "Update_Builder",
    Update_Client = "Update_Client",
    Update_Costing = "Update_Costing",
    Update_Quote_Request = "Update_Quote_Request",
    Update_Supplier_Quote = "Update_Supplier_Quote",
    Update_Document_Template = "Update_Document_Template",
    Update_Draft_Schema_Version = "Update_Draft_Schema_Version",
    Update_Housing_Company = "Update_Housing_Company",
    Update_Issue = "Update_Issue",
    Update_Job_Builder = "Update_Job_Builder",
    Update_Job_Client = "Update_Job_Client",
    Update_Job_Custom_Data = "Update_Job_Custom_Data",
    Update_Job_Details = "Update_Job_Details",
    Update_Job_Note = "Update_Job_Note",
    Update_Job_Component = "Update_Job_Component",
    Update_Job_Part = "Update_Job_Part",
    Update_Job_Site = "Update_Job_Site",
    Update_Lead = "Update_Lead",
    Update_Lost_Reason = "Update_Lost_Reason",
    Update_Panel = "Update_Panel",
    Update_Part_Type = "Update_Part_Type",
    Update_Person = "Update_Person",
    Update_Business_Role = "Update_Business_Role",
    Update_Process_Instance_Details = "Update_Process_Instance_Details",
    Update_Process_Instance_Status = "Update_Process_Instance_Status",
    Update_Process_Type_Details = "Update_Process_Type_Details",
    Update_Process_Type_Role = "Update_Process_Type_Role",
    Update_Process_Type_Note = "Update_Process_Type_Note",
    Update_Product_Category = "Update_Product_Category",
    Update_Product_Details = "Update_Product_Details",
    Update_Purchase_Order = "Update_Purchase_Order",
    Update_Sales_Order = "Update_Sales_Order",
    Update_Role = "Update_Role",
    Update_Schema_Details = "Update_Schema_Details",
    Update_Screen = "Update_Screen",
    Update_Storage_Connection = "Update_Storage_Connection",
    Update_Storage_Resource_Mapping = "Update_Storage_Resource_Mapping",
    Update_Supplier_Details = "Update_Supplier_Details",
    Update_Supplier_Reviewers = "Update_Supplier_Reviewers",
    Update_Tag = "Update_Tag",
    Update_User = "Update_User",
    Update_User_Details = "Update_User_Details",
    Update_User_Identities = "Update_User_Identities",
    Update_User_Permissions = "Update_User_Permissions",
    Update_Warehouse = "Update_Warehouse",
    Update_Warehouse_Stock = "Update_Warehouse_Stock",
    Update_Webhook = "Update_Webhook",
    Update_Workflow_Type_Details = "Update_Workflow_Type_Details",
    Delete_Batches = "Delete_Batches",
    Delete_Branches = "Delete_Branches",
    Delete_Business_Role = "Delete_Business_Role",
    Delete_Builders = "Delete_Builders",
    Delete_Clients = "Delete_Clients",
    Delete_Correspondence = "Delete_Correspondence",
    Delete_Costing = "Delete_Costing",
    Delete_Document_Template = "Delete_Document_Template",
    Delete_Draft_Purchase_Orders = "Delete_Draft_Purchase_Orders",
    Delete_Files = "Delete_Files",
    Delete_Housing_Companies = "Delete_Housing_Companies",
    Delete_Housing_Company_Image = "Delete_Housing_Company_Image",
    Delete_Job_Component = "Delete_Job_Component",
    Delete_Job_Parts = "Delete_Job_Parts",
    Delete_Jobs = "Delete_Jobs",
    Delete_Leads = "Delete_Leads",
    Delete_Lost_Reasons = "Delete_Lost_Reasons",
    Delete_Panels = "Delete_Panels",
    Delete_Part_Types = "Delete_Part_Types",
    Delete_Process_Types = "Delete_Process_Types",
    Delete_Process_Type_Roles = "Delete_Process_Type_Roles",
    Delete_Process_Type_Note = "Delete_Process_Type_Note",
    Delete_Product_Categories = "Delete_Product_Categories",
    Delete_Product_Prices = "Delete_Product_Prices",
    Delete_Purchase_Orders = "Delete_Purchase_Orders",
    Delete_Quote = "Delete_Quote",
    Delete_Quote_Template = "Delete_Quote_Template",
    Delete_Quote_Request = "Delete_Quote_Request",
    Delete_Sales_Order = "Delete_Sales_Order",
    Delete_Supplier_Quote = "Delete_Supplier_Quote",
    Delete_Role = "Delete_Role",
    Delete_Schema = "Delete_Schema",
    Delete_Schema_Version = "Delete_Schema_Version",
    Delete_Screens = "Delete_Screens",
    Delete_Storage_Connection = "Delete_Storage_Connection",
    Delete_Storage_Resource_Mapping = "Delete_Storage_Resource_Mapping",
    Delete_Subscription = "Delete_Subscription",
    Delete_Supplier_Image = "Delete_Supplier_Image",
    Delete_Suppliers = "Delete_Suppliers",
    Delete_Tag = "Delete_Tag",
    Delete_User = "Delete_User",
    Delete_User_Identities = "Delete_User_Identities",
    Delete_Warehouse = "Delete_Warehouse",
    Delete_Webhooks = "Delete_Webhooks",
    Delete_Workflow_Types = "Delete_Workflow_Types",
    Query_AI_Gen = "Query_AI_Gen",
    Query_Async_Tasks = "Query_Async_Tasks",
    Query_Audit_Logs = "Query_Audit_Logs",
    Query_Batch_Schedules = "Query_Batch_Schedules",
    Query_Batches = "Query_Batches",
    Query_Build_Types = "Query_Build_Types",
    Query_Builders = "Query_Builders",
    Query_Branches = "Query_Branches",
    Query_Candidate_Ingestion_Policies = "Query_Candidate_Ingestion_Policies",
    Query_Candidates = "Query_Candidates",
    Query_Clients = "Query_Clients",
    Query_Custom_Data = "Query_Custom_Data",
    Query_Custom_Templates = "Query_Custom_Templates",
    Query_Document_Templates = "Query_Document_Templates",
    Query_Costing_Lines = "Query_Costing_Lines",
    Query_Costing_Line_Templates = "Query_Costing_Line_Templates",
    Query_Costing_Revisions = "Query_Costing_Revisions",
    Query_Costing_Templates = "Query_Costing_Templates",
    Query_Costing_Template_Expressions = "Query_Costing_Template_Expressions",
    Query_Costings = "Query_Costings",
    Query_Costing_Template_Revisions = "Query_Costing_Template_Revisions",
    Query_Correspondence = "Query_Correspondence",
    Query_Download_Request_Url = "Query_Download_Request_Url",
    Query_Storage_Connections = "Query_Storage_Connections",
    Query_Storage_Resource_Mappings = "Query_Storage_Resource_Mappings",
    Query_Files = "Query_Files",
    Query_Default_Folders = "Query_Default_Folders",
    Set_Default_Folder = "Set_Default_Folder",
    Query_Record_Folders = "Query_Record_Folders",
    Query_Housing_Companies = "Query_Housing_Companies",
    Query_Issues = "Query_Issues",
    Query_Jobs = "Query_Jobs",
    Query_Job_Components = "Query_Job_Components",
    Query_Job_Parts = "Query_Job_Parts",
    Report_Confirmed_Sales = "Report_Confirmed_Sales",
    Query_Line_Item_Master_Workflows = "Query_Line_Item_Master_Workflows",
    Query_Legacy_User_Roles = "Query_Legacy_User_Roles",
    Query_Leads = "Query_Leads",
    Query_Lost_Reasons = "Query_Lost_Reasons",
    Query_Panels = "Query_Panels",
    Query_Part_Types = "Query_Part_Types",
    Query_People = "Query_People",
    Query_Person_Assigned_Work = "Query_Person_Assigned_Work",
    Query_Business_Roles = "Query_Business_Roles",
    Query_Person_Business_Roles = "Query_Person_Business_Roles",
    Query_Assets = "Query_Assets",
    Query_Process_Assets = "Query_Process_Assets",
    Query_Process_Instances = "Query_Process_Instances",
    Query_Process_Assignments = "Query_Process_Assignments",
    Query_Process_Templates = "Query_Process_Templates",
    Query_Process_Timers = "Query_Process_Timers",
    Query_Process_Timer_Items = "Query_Process_Timer_Items",
    Query_Timer_Transactions = "Query_Timer_Transactions",
    Query_Process_Types = "Query_Process_Types",
    Query_Process_Type_Notes = "Query_Process_Type_Notes",
    Query_Process_Type_Roles = "Query_Process_Type_Roles",
    Query_Product_Categories = "Query_Product_Categories",
    Query_Product_Category_Groups = "Query_Product_Category_Groups",
    Query_Product_Prices = "Query_Product_Prices",
    Query_Products = "Query_Products",
    Query_Projects = "Query_Projects",
    Query_Purchase_Order_Lines = "Query_Purchase_Order_Lines",
    Query_Purchase_Order_Receipts = "Query_Purchase_Order_Receipts",
    Query_Purchase_Order_Receipt_Lines = "Query_Purchase_Order_Receipt_Lines",
    Query_Purchase_Order_Reviews = "Query_Purchase_Order_Reviews",
    Query_Purchase_Orders = "Query_Purchase_Orders",
    Query_Delivery_Addresses = "Query_Delivery_Addresses",
    Query_Quote_Requests = "Query_Quote_Requests",
    Query_Quote_Lines = "Query_Quote_Lines",
    Query_Quote_Line_Templates = "Query_Quote_Line_Templates",
    Query_Quote_Revisions = "Query_Quote_Revisions",
    Query_Quote_Request_Lines = "Query_Quote_Request_Lines",
    Query_Quote_Templates = "Query_Quote_Templates",
    Query_Quote_Template_Expressions = "Query_Quote_Template_Expressions",
    Query_Quote_Template_Revisions = "Query_Quote_Template_Revisions",
    Query_Quotes = "Query_Quotes",
    Query_Record_Files = "Query_Record_Files",
    Query_Record_Tags = "Query_Record_Tags",
    Query_Record_Screens = "Query_Record_Screens",
    Query_Regions = "Query_Regions",
    Query_Role_Inheritances = "Query_Role_Inheritances",
    Query_Role_Permissions = "Query_Role_Permissions",
    Query_Role_Users = "Query_Role_Users",
    Query_Roles = "Query_Roles",
    Query_Sales_Orders = "Query_Sales_Orders",
    Query_Sales_Order_Lines = "Query_Sales_Order_Lines",
    Query_Sale_Types = "Query_Sale_Types",
    Query_Schemas = "Query_Schemas",
    Query_Schema_Versions = "Query_Schema_Versions",
    Query_Screens = "Query_Screens",
    Query_Stock = "Query_Stock",
    Query_Stock_Transaction_Lines = "Query_Stock_Transaction_Lines",
    Query_Stock_Transactions = "Query_Stock_Transactions",
    Query_Subscriptions = "Query_Subscriptions",
    Query_Notification_Templates = "Query_Notification_Templates",
    Query_Attachment_Templates = "Query_Attachment_Templates",
    Query_Supplier_Categories = "Query_Supplier_Categories",
    Query_Suppliers = "Query_Suppliers",
    Query_Tags = "Query_Tags",
    Query_Transactional_Emails = "Query_Transactional_Emails",
    Query_Supplier_Quotes = "Query_Supplier_Quotes",
    Query_Supplier_Quote_Lines = "Query_Supplier_Quote_Lines",
    Query_Upload_Request_Url = "Query_Upload_Request_Url",
    Query_User_Identities = "Query_User_Identities",
    Query_User_Permissions = "Query_User_Permissions",
    Query_Users = "Query_Users",
    Query_Warehouses = "Query_Warehouses",
    Query_Webhooks = "Query_Webhooks",
    Query_Group_Templates = "Query_Group_Templates",
    Query_Workflow_Notes = "Query_Workflow_Notes",
    Query_Workflow_Templates = "Query_Workflow_Templates",
    Query_Workflow_Types = "Query_Workflow_Types",
    Accept_Quote = "Accept_Quote",
    Act_As_User = "Act_As_User",
    Admin_Act_As_User = "Admin_Act_As_User",
    Activate_Person = "Activate_Person",
    Amend_Purchase_Order = "Amend_Purchase_Order",
    Assign_Leads_To_Salesperson = "Assign_Leads_To_Salesperson",
    Assign_Business_Roles = "Assign_Business_Roles",
    Assign_Permissions = "Assign_Permissions",
    Assign_Users_To_Process_Instances = "Assign_Users_To_Process_Instances",
    Assign_Roles = "Assign_Roles",
    Assign_Screens = "Assign_Screens",
    Bulk_Product_Import = "Bulk_Product_Import",
    Generate_Current_Product_Pricing = "Generate_Current_Product_Pricing",
    Cancel_Purchase_Orders = "Cancel_Purchase_Orders",
    Cancel_Quote_Request = "Cancel_Quote_Request",
    Cancel_Sales_Order = "Cancel_Sales_Order",
    Cleanup_Files = "Cleanup_Files",
    Clear_Permission_Cache = "Clear_Permission_Cache",
    Deactivate_Person = "Deactivate_Person",
    Disable_User = "Disable_User",
    Enable_User = "Enable_User",
    Reset_User_Password = "Reset_User_Password",
    Set_User_Pin = "Set_User_Pin",
    Unset_User_Pin = "Unset_User_Pin",
    Issue_Quote = "Issue_Quote",
    Confirm_Sales_Order = "Confirm_Sales_Order",
    Override_Lead_Status = "Override_Lead_Status",
    Override_Purchase_Order_Status = "Override_Purchase_Order_Status",
    Promote_Schema_Version = "Promote_Schema_Version",
    Read_Job_Custom_Data = "Read_Job_Custom_Data",
    Reschedule_Batches = "Reschedule_Batches",
    Release_Purchase_Orders = "Release_Purchase_Orders",
    Resend_Purchase_Order_Supplier_Notification = "Resend_Purchase_Order_Supplier_Notification",
    Restore_Part_Types = "Restore_Part_Types",
    Restore_Process_Types = "Restore_Process_Types",
    Restore_Workflow_Types = "Restore_Workflow_Types",
    Transfer_Warehouse_Stock = "Transfer_Warehouse_Stock",
    Trigger_Webhook = "Trigger_Webhook",
    Unassign_Leads_From_Salesperson = "Unassign_Leads_From_Salesperson",
    Unassign_Business_Roles = "Unassign_Business_Roles",
    Unassign_Permissions = "Unassign_Permissions",
    Unassign_Roles = "Unassign_Roles",
    Unassign_Screens = "Unassign_Screens",
    Upload_File = "Upload_File"
}
export type PermissionConditionalPolicyInputTypes = {
    [Permission.Query_Configured_Linked_Actions]: ConfiguredLinkedActionFilterInput;
    [Permission.Query_Linked_Actions]: LinkedActionFilterInput;
    [Permission.Query_Async_Tasks]: AsyncTaskFilterInput;
    [Permission.Query_Audit_Logs]: AuditLogFilterInput;
    [Permission.Query_Batch_Schedules]: BatchScheduleFilterInput;
    [Permission.Query_Batches]: BatchFilterInput;
    [Permission.Query_Build_Types]: BuildTypeFilterInput;
    [Permission.Query_Builders]: BuilderFilterInput;
    [Permission.Query_Branches]: BranchFilterInput;
    [Permission.Query_Candidate_Ingestion_Policies]: CandidateIngestionPolicyFilterInput;
    [Permission.Query_Candidates]: CandidateFilterInput;
    [Permission.Query_Clients]: ClientFilterInput;
    [Permission.Query_Custom_Data]: CustomDataFilterInput;
    [Permission.Query_Custom_Templates]: CustomTemplateFilterInput;
    [Permission.Query_Document_Templates]: DocumentTemplateFilterInput;
    [Permission.Query_Costing_Lines]: CostingLineFilterInput;
    [Permission.Query_Costing_Line_Templates]: CostingLineTemplateFilterInput;
    [Permission.Query_Costing_Revisions]: CostingRevisionFilterInput;
    [Permission.Query_Costing_Templates]: CostingTemplateFilterInput;
    [Permission.Query_Costing_Template_Expressions]: CostingTemplateExpressionFilterInput;
    [Permission.Query_Costings]: CostingFilterInput;
    [Permission.Query_Costing_Template_Revisions]: CostingTemplateRevisionFilterInput;
    [Permission.Query_Correspondence]: CorrespondenceFilterInput;
    [Permission.Query_Storage_Connections]: ExternalStorageConnectionFilterInput;
    [Permission.Query_Storage_Resource_Mappings]: ExternalStorageResourceMappingFilterInput;
    [Permission.Query_Files]: FileFilterInput;
    [Permission.Query_Default_Folders]: DefaultFolderFilterInput;
    [Permission.Query_Record_Folders]: RecordFolderFilterInput;
    [Permission.Query_Housing_Companies]: HousingCompanyFilterInput;
    [Permission.Query_Issues]: IssueFilterInput;
    [Permission.Query_Jobs]: JobFilterInput;
    [Permission.Query_Job_Components]: JobComponentFilterInput;
    [Permission.Query_Job_Parts]: LineItemFilterInput;
    [Permission.Query_Line_Item_Master_Workflows]: LineItemMasterWorkflowFilterInput;
    [Permission.Query_Legacy_User_Roles]: UserRoleFilterInput;
    [Permission.Query_Leads]: LeadFilterInput;
    [Permission.Query_Lost_Reasons]: LostReasonFilterInput;
    [Permission.Query_Panels]: PanelFilterInput;
    [Permission.Query_Part_Types]: PartTypeFilterInput;
    [Permission.Query_People]: PersonFilterInput;
    [Permission.Query_Person_Assigned_Work]: PersonAssignedWorkFilterInput;
    [Permission.Query_Business_Roles]: BusinessRoleFilterInput;
    [Permission.Query_Person_Business_Roles]: PersonBusinessRoleFilterInput;
    [Permission.Query_Assets]: AssetFilterInput;
    [Permission.Query_Process_Assets]: ProcessAssetFilterInput;
    [Permission.Query_Process_Instances]: ProcessInstanceFilterInput;
    [Permission.Query_Process_Assignments]: ProcessAssignmentFilterInput;
    [Permission.Query_Process_Templates]: ProcessTemplateFilterInput;
    [Permission.Query_Process_Timers]: ProcessTimerFilterInput;
    [Permission.Query_Process_Timer_Items]: ProcessTimerItemFilterInput;
    [Permission.Query_Timer_Transactions]: TimerTransactionFilterInput;
    [Permission.Query_Process_Types]: ProcessTypeFilterInput;
    [Permission.Query_Process_Type_Notes]: ProcessTypeNoteFilterInput;
    [Permission.Query_Process_Type_Roles]: ProcessTypeRoleFilterInput;
    [Permission.Query_Product_Categories]: ProductCategoryFilterInput;
    [Permission.Query_Product_Category_Groups]: ProductCategoryGroupFilterInput;
    [Permission.Query_Product_Prices]: ProductPriceFilterInput;
    [Permission.Query_Products]: ProductFilterInput;
    [Permission.Query_Projects]: ProjectFilterInput;
    [Permission.Query_Purchase_Order_Lines]: PurchaseOrderLineFilterInput;
    [Permission.Query_Purchase_Order_Receipts]: PurchaseOrderReceiptFilterInput;
    [Permission.Query_Purchase_Order_Receipt_Lines]: PurchaseOrderReceiptLineFilterInput;
    [Permission.Query_Purchase_Order_Reviews]: PurchaseOrderReviewFilterInput;
    [Permission.Query_Purchase_Orders]: PurchaseOrderFilterInput;
    [Permission.Query_Delivery_Addresses]: DeliveryAddressFilterInput;
    [Permission.Query_Quote_Requests]: SupplierQuoteRequestFilterInput;
    [Permission.Query_Quote_Lines]: QuoteLineFilterInput;
    [Permission.Query_Quote_Line_Templates]: QuoteLineTemplateFilterInput;
    [Permission.Query_Quote_Revisions]: QuoteRevisionFilterInput;
    [Permission.Query_Quote_Request_Lines]: SupplierQuoteRequestLineFilterInput;
    [Permission.Query_Quote_Templates]: QuoteTemplateFilterInput;
    [Permission.Query_Quote_Template_Expressions]: QuoteTemplateExpressionFilterInput;
    [Permission.Query_Quote_Template_Revisions]: QuoteTemplateRevisionFilterInput;
    [Permission.Query_Quotes]: QuoteFilterInput;
    [Permission.Query_Record_Files]: RecordFileFilterInput;
    [Permission.Query_Record_Tags]: RecordTagFilterInput;
    [Permission.Query_Record_Screens]: RecordScreenFilterInput;
    [Permission.Query_Regions]: RegionFilterInput;
    [Permission.Query_Role_Inheritances]: RoleInheritanceFilterInput;
    [Permission.Query_Role_Permissions]: RolePermissionFilterInput;
    [Permission.Query_Role_Users]: RoleUserFilterInput;
    [Permission.Query_Roles]: RoleFilterInput;
    [Permission.Query_Sales_Orders]: SalesOrderFilterInput;
    [Permission.Query_Sales_Order_Lines]: SalesOrderLineFilterInput;
    [Permission.Query_Sale_Types]: SaleTypeFilterInput;
    [Permission.Query_Schemas]: SchemaFilterInput;
    [Permission.Query_Schema_Versions]: SchemaVersionFilterInput;
    [Permission.Query_Screens]: ScreenFilterInput;
    [Permission.Query_Stock]: StockFilterInput;
    [Permission.Query_Stock_Transaction_Lines]: StockTransactionLineFilterInput;
    [Permission.Query_Stock_Transactions]: StockTransactionFilterInput;
    [Permission.Query_Subscriptions]: SubscriptionRealFilterInput;
    [Permission.Query_Notification_Templates]: NotificationTemplateFilterInput;
    [Permission.Query_Attachment_Templates]: AttachmentTemplateFilterInput;
    [Permission.Query_Supplier_Categories]: SupplierCategoryFilterInput;
    [Permission.Query_Suppliers]: SupplierFilterInput;
    [Permission.Query_Tags]: TagFilterInput;
    [Permission.Query_Transactional_Emails]: EmailFilterInput;
    [Permission.Query_Supplier_Quotes]: SupplierQuoteFilterInput;
    [Permission.Query_Supplier_Quote_Lines]: SupplierQuoteLineFilterInput;
    [Permission.Query_User_Identities]: UserIdentityFilterInput;
    [Permission.Query_User_Permissions]: UserPermissionFilterInput;
    [Permission.Query_Users]: UserFilterInput;
    [Permission.Query_Warehouses]: WarehouseFilterInput;
    [Permission.Query_Webhooks]: WebhookFilterInput;
    [Permission.Query_Group_Templates]: GroupTemplateFilterInput;
    [Permission.Query_Workflow_Notes]: WorkflowNoteFilterInput;
    [Permission.Query_Workflow_Templates]: WorkflowTemplateFilterInput;
    [Permission.Query_Workflow_Types]: WorkflowTypeFilterInput;
    [Permission.Act_As_User]: ActAsUserFilterInput;
    [Permission.Admin_Act_As_User]: ActAsUserFilterInput;
};
export const PermissionDescriptions: Partial<Record<Permission, string>> = {
    [Permission.Create_Batch]: "",
    [Permission.Create_Branch]: "",
    [Permission.Create_Builder]: "",
    [Permission.Create_Candidate]: "",
    [Permission.Create_Client]: "",
    [Permission.Create_Costing]: "",
    [Permission.Create_Costing_Template]: "",
    [Permission.Create_Document_Template]: "",
    [Permission.Create_Files]: "",
    [Permission.Create_Firebase_Auth_Token]: "",
    [Permission.Create_Housing_Company]: "",
    [Permission.Create_Housing_Company_Image]: "",
    [Permission.Create_Issue]: "",
    [Permission.Create_Job]: "",
    [Permission.Create_Job_Component]: "",
    [Permission.Create_Job_File]: "",
    [Permission.Create_Job_Part]: "",
    [Permission.Create_Lead]: "",
    [Permission.Create_Lost_Reason]: "",
    [Permission.Create_Panel]: "",
    [Permission.Create_Part_Type]: "",
    [Permission.Create_Person]: "",
    [Permission.Create_Business_Role]: "",
    [Permission.Create_Process_Type]: "",
    [Permission.Create_Process_Type_Role]: "",
    [Permission.Create_Process_Type_Note]: "",
    [Permission.Create_Product]: "",
    [Permission.Create_Product_Category]: "",
    [Permission.Create_Product_Price]: "",
    [Permission.Create_Purchase_Order]: "",
    [Permission.Create_Purchase_Order_Receipt]: "",
    [Permission.Create_Quote]: "",
    [Permission.Create_Quote_Request]: "",
    [Permission.Create_Quote_Template]: "",
    [Permission.Create_Role]: "",
    [Permission.Create_Sales_Order]: "",
    [Permission.Create_Role_Screen]: "",
    [Permission.Create_Schema]: "",
    [Permission.Create_Schema_Version]: "",
    [Permission.Create_Screen]: "",
    [Permission.Create_Storage_Connection]: "",
    [Permission.Create_Storage_Resource_Mapping]: "",
    [Permission.Create_Subscription]: "",
    [Permission.Create_Supplier]: "",
    [Permission.Create_Supplier_Image]: "",
    [Permission.Create_Supplier_Quote]: "",
    [Permission.Create_Tag]: "",
    [Permission.Create_User]: "",
    [Permission.Create_User_Identity]: "",
    [Permission.Create_Warehouse]: "",
    [Permission.Query_Configured_Linked_Actions]: "",
    [Permission.Manage_Configured_Linked_Actions]: "",
    [Permission.Query_Linked_Actions]: "",
    [Permission.Manage_Favourite_Linked_Actions]: "",
    [Permission.Create_Webhook]: "",
    [Permission.Create_Workflow_Type]: "",
    [Permission.Convert_Candidate]: "",
    [Permission.Set_Candidate_Ingestion_Policy]: "",
    [Permission.Update_Batch_Details]: "",
    [Permission.Update_Branch]: "",
    [Permission.Update_Builder]: "",
    [Permission.Update_Client]: "",
    [Permission.Update_Costing]: "",
    [Permission.Update_Quote_Request]: "",
    [Permission.Update_Supplier_Quote]: "",
    [Permission.Update_Document_Template]: "",
    [Permission.Update_Draft_Schema_Version]: "",
    [Permission.Update_Housing_Company]: "",
    [Permission.Update_Issue]: "",
    [Permission.Update_Job_Builder]: "",
    [Permission.Update_Job_Client]: "",
    [Permission.Update_Job_Custom_Data]: "",
    [Permission.Update_Job_Details]: "",
    [Permission.Update_Job_Note]: "",
    [Permission.Update_Job_Component]: "",
    [Permission.Update_Job_Part]: "",
    [Permission.Update_Job_Site]: "",
    [Permission.Update_Lead]: "",
    [Permission.Update_Lost_Reason]: "",
    [Permission.Update_Panel]: "",
    [Permission.Update_Part_Type]: "",
    [Permission.Update_Person]: "",
    [Permission.Update_Business_Role]: "",
    [Permission.Update_Process_Instance_Details]: "",
    [Permission.Update_Process_Instance_Status]: "",
    [Permission.Update_Process_Type_Details]: "",
    [Permission.Update_Process_Type_Role]: "",
    [Permission.Update_Process_Type_Note]: "",
    [Permission.Update_Product_Category]: "",
    [Permission.Update_Product_Details]: "",
    [Permission.Update_Purchase_Order]: "",
    [Permission.Update_Sales_Order]: "",
    [Permission.Update_Role]: "",
    [Permission.Update_Schema_Details]: "",
    [Permission.Update_Screen]: "",
    [Permission.Update_Storage_Connection]: "",
    [Permission.Update_Storage_Resource_Mapping]: "",
    [Permission.Update_Supplier_Details]: "",
    [Permission.Update_Supplier_Reviewers]: "",
    [Permission.Update_Tag]: "",
    [Permission.Update_User]: "",
    [Permission.Update_User_Details]: "",
    [Permission.Update_User_Identities]: "",
    [Permission.Update_User_Permissions]: "",
    [Permission.Update_Warehouse]: "",
    [Permission.Update_Warehouse_Stock]: "",
    [Permission.Update_Webhook]: "",
    [Permission.Update_Workflow_Type_Details]: "",
    [Permission.Delete_Batches]: "",
    [Permission.Delete_Branches]: "",
    [Permission.Delete_Business_Role]: "",
    [Permission.Delete_Builders]: "",
    [Permission.Delete_Clients]: "",
    [Permission.Delete_Correspondence]: "",
    [Permission.Delete_Costing]: "",
    [Permission.Delete_Document_Template]: "",
    [Permission.Delete_Draft_Purchase_Orders]: "",
    [Permission.Delete_Files]: "",
    [Permission.Delete_Housing_Companies]: "",
    [Permission.Delete_Housing_Company_Image]: "",
    [Permission.Delete_Job_Component]: "",
    [Permission.Delete_Job_Parts]: "",
    [Permission.Delete_Jobs]: "",
    [Permission.Delete_Leads]: "",
    [Permission.Delete_Lost_Reasons]: "",
    [Permission.Delete_Panels]: "",
    [Permission.Delete_Part_Types]: "",
    [Permission.Delete_Process_Types]: "",
    [Permission.Delete_Process_Type_Roles]: "",
    [Permission.Delete_Process_Type_Note]: "",
    [Permission.Delete_Product_Categories]: "",
    [Permission.Delete_Product_Prices]: "",
    [Permission.Delete_Purchase_Orders]: "",
    [Permission.Delete_Quote]: "",
    [Permission.Delete_Quote_Template]: "",
    [Permission.Delete_Quote_Request]: "",
    [Permission.Delete_Sales_Order]: "",
    [Permission.Delete_Supplier_Quote]: "",
    [Permission.Delete_Role]: "",
    [Permission.Delete_Schema]: "",
    [Permission.Delete_Schema_Version]: "",
    [Permission.Delete_Screens]: "",
    [Permission.Delete_Storage_Connection]: "",
    [Permission.Delete_Storage_Resource_Mapping]: "",
    [Permission.Delete_Subscription]: "",
    [Permission.Delete_Supplier_Image]: "",
    [Permission.Delete_Suppliers]: "",
    [Permission.Delete_Tag]: "",
    [Permission.Delete_User]: "",
    [Permission.Delete_User_Identities]: "",
    [Permission.Delete_Warehouse]: "",
    [Permission.Delete_Webhooks]: "",
    [Permission.Delete_Workflow_Types]: "",
    [Permission.Query_AI_Gen]: "",
    [Permission.Query_Async_Tasks]: "",
    [Permission.Query_Audit_Logs]: "",
    [Permission.Query_Batch_Schedules]: "",
    [Permission.Query_Batches]: "",
    [Permission.Query_Build_Types]: "",
    [Permission.Query_Builders]: "",
    [Permission.Query_Branches]: "",
    [Permission.Query_Candidate_Ingestion_Policies]: "",
    [Permission.Query_Candidates]: "",
    [Permission.Query_Clients]: "",
    [Permission.Query_Custom_Data]: "",
    [Permission.Query_Custom_Templates]: "",
    [Permission.Query_Document_Templates]: "",
    [Permission.Query_Costing_Lines]: "",
    [Permission.Query_Costing_Line_Templates]: "",
    [Permission.Query_Costing_Revisions]: "",
    [Permission.Query_Costing_Templates]: "",
    [Permission.Query_Costing_Template_Expressions]: "",
    [Permission.Query_Costings]: "",
    [Permission.Query_Costing_Template_Revisions]: "",
    [Permission.Query_Correspondence]: "",
    [Permission.Query_Download_Request_Url]: "",
    [Permission.Query_Storage_Connections]: "",
    [Permission.Query_Storage_Resource_Mappings]: "",
    [Permission.Query_Files]: "",
    [Permission.Query_Default_Folders]: "",
    [Permission.Set_Default_Folder]: "",
    [Permission.Query_Record_Folders]: "",
    [Permission.Query_Housing_Companies]: "",
    [Permission.Query_Issues]: "",
    [Permission.Query_Jobs]: "",
    [Permission.Query_Job_Components]: "",
    [Permission.Query_Job_Parts]: "",
    [Permission.Report_Confirmed_Sales]: "",
    [Permission.Query_Line_Item_Master_Workflows]: "",
    [Permission.Query_Legacy_User_Roles]: "",
    [Permission.Query_Leads]: "",
    [Permission.Query_Lost_Reasons]: "",
    [Permission.Query_Panels]: "",
    [Permission.Query_Part_Types]: "",
    [Permission.Query_People]: "",
    [Permission.Query_Person_Assigned_Work]: "",
    [Permission.Query_Business_Roles]: "",
    [Permission.Query_Person_Business_Roles]: "",
    [Permission.Query_Assets]: "",
    [Permission.Query_Process_Assets]: "",
    [Permission.Query_Process_Instances]: "",
    [Permission.Query_Process_Assignments]: "",
    [Permission.Query_Process_Templates]: "",
    [Permission.Query_Process_Timers]: "",
    [Permission.Query_Process_Timer_Items]: "",
    [Permission.Query_Timer_Transactions]: "",
    [Permission.Query_Process_Types]: "",
    [Permission.Query_Process_Type_Notes]: "",
    [Permission.Query_Process_Type_Roles]: "",
    [Permission.Query_Product_Categories]: "",
    [Permission.Query_Product_Category_Groups]: "",
    [Permission.Query_Product_Prices]: "",
    [Permission.Query_Products]: "",
    [Permission.Query_Projects]: "",
    [Permission.Query_Purchase_Order_Lines]: "",
    [Permission.Query_Purchase_Order_Receipts]: "",
    [Permission.Query_Purchase_Order_Receipt_Lines]: "",
    [Permission.Query_Purchase_Order_Reviews]: "",
    [Permission.Query_Purchase_Orders]: "",
    [Permission.Query_Delivery_Addresses]: "",
    [Permission.Query_Quote_Requests]: "",
    [Permission.Query_Quote_Lines]: "",
    [Permission.Query_Quote_Line_Templates]: "",
    [Permission.Query_Quote_Revisions]: "",
    [Permission.Query_Quote_Request_Lines]: "",
    [Permission.Query_Quote_Templates]: "",
    [Permission.Query_Quote_Template_Expressions]: "",
    [Permission.Query_Quote_Template_Revisions]: "",
    [Permission.Query_Quotes]: "",
    [Permission.Query_Record_Files]: "",
    [Permission.Query_Record_Tags]: "",
    [Permission.Query_Record_Screens]: "",
    [Permission.Query_Regions]: "",
    [Permission.Query_Role_Inheritances]: "",
    [Permission.Query_Role_Permissions]: "",
    [Permission.Query_Role_Users]: "",
    [Permission.Query_Roles]: "",
    [Permission.Query_Sales_Orders]: "",
    [Permission.Query_Sales_Order_Lines]: "",
    [Permission.Query_Sale_Types]: "",
    [Permission.Query_Schemas]: "",
    [Permission.Query_Schema_Versions]: "",
    [Permission.Query_Screens]: "",
    [Permission.Query_Stock]: "",
    [Permission.Query_Stock_Transaction_Lines]: "",
    [Permission.Query_Stock_Transactions]: "",
    [Permission.Query_Subscriptions]: "",
    [Permission.Query_Notification_Templates]: "",
    [Permission.Query_Attachment_Templates]: "",
    [Permission.Query_Supplier_Categories]: "",
    [Permission.Query_Suppliers]: "",
    [Permission.Query_Tags]: "",
    [Permission.Query_Transactional_Emails]: "",
    [Permission.Query_Supplier_Quotes]: "",
    [Permission.Query_Supplier_Quote_Lines]: "",
    [Permission.Query_Upload_Request_Url]: "",
    [Permission.Query_User_Identities]: "",
    [Permission.Query_User_Permissions]: "",
    [Permission.Query_Users]: "",
    [Permission.Query_Warehouses]: "",
    [Permission.Query_Webhooks]: "",
    [Permission.Query_Group_Templates]: "",
    [Permission.Query_Workflow_Notes]: "",
    [Permission.Query_Workflow_Templates]: "",
    [Permission.Query_Workflow_Types]: "",
    [Permission.Accept_Quote]: "",
    [Permission.Act_As_User]: "",
    [Permission.Admin_Act_As_User]: "",
    [Permission.Activate_Person]: "",
    [Permission.Amend_Purchase_Order]: "",
    [Permission.Assign_Leads_To_Salesperson]: "",
    [Permission.Assign_Business_Roles]: "",
    [Permission.Assign_Permissions]: "",
    [Permission.Assign_Users_To_Process_Instances]: "",
    [Permission.Assign_Roles]: "",
    [Permission.Assign_Screens]: "",
    [Permission.Bulk_Product_Import]: "",
    [Permission.Generate_Current_Product_Pricing]: "",
    [Permission.Cancel_Purchase_Orders]: "",
    [Permission.Cancel_Quote_Request]: "",
    [Permission.Cancel_Sales_Order]: "",
    [Permission.Cleanup_Files]: "",
    [Permission.Clear_Permission_Cache]: "",
    [Permission.Deactivate_Person]: "",
    [Permission.Disable_User]: "",
    [Permission.Enable_User]: "",
    [Permission.Reset_User_Password]: "",
    [Permission.Set_User_Pin]: "",
    [Permission.Unset_User_Pin]: "",
    [Permission.Issue_Quote]: "",
    [Permission.Confirm_Sales_Order]: "",
    [Permission.Override_Lead_Status]: "",
    [Permission.Override_Purchase_Order_Status]: "",
    [Permission.Promote_Schema_Version]: "",
    [Permission.Read_Job_Custom_Data]: "",
    [Permission.Reschedule_Batches]: "",
    [Permission.Release_Purchase_Orders]: "",
    [Permission.Resend_Purchase_Order_Supplier_Notification]: "",
    [Permission.Restore_Part_Types]: "",
    [Permission.Restore_Process_Types]: "",
    [Permission.Restore_Workflow_Types]: "",
    [Permission.Transfer_Warehouse_Stock]: "",
    [Permission.Trigger_Webhook]: "",
    [Permission.Unassign_Leads_From_Salesperson]: "",
    [Permission.Unassign_Business_Roles]: "",
    [Permission.Unassign_Permissions]: "",
    [Permission.Unassign_Roles]: "",
    [Permission.Unassign_Screens]: "",
    [Permission.Upload_File]: ""
};
